import { useTranslation } from "react-i18next";
import { rowsPerPageOptionsValues } from "../utils";
import { Props } from "./interfaces";
import { TablePagination } from "./styles";
import { CUSTOM_PAGINATION_ID } from "./utils";

const CustomTablePagination = ({
  totalItems = 0,
  pageNumber = 0,
  handleChangePageNumber,
  rowsPerPageOptions = rowsPerPageOptionsValues,
  pageSize = 10,
  handleChangePageSize,
  outlined,
  labelRowsPerPage,
}: Props): JSX.Element => {
  const { t } = useTranslation();
  const tRP = "components.pagination";

  return (
    <TablePagination
      component="div"
      outlined={outlined}
      count={totalItems}
      page={pageNumber}
      onPageChange={(_, pageNumber) => handleChangePageNumber(pageNumber)}
      rowsPerPageOptions={rowsPerPageOptions}
      rowsPerPage={pageSize}
      onRowsPerPageChange={(e) => handleChangePageSize && handleChangePageSize(+e.target.value)}
      id={CUSTOM_PAGINATION_ID}
      labelRowsPerPage={labelRowsPerPage ?? t(`${tRP}.rows_per_page`)}
      labelDisplayedRows={({ from, to, count }) => t(`${tRP}.displayed_rows`, { from, to, count })}
    />
  );
};

export default CustomTablePagination;
